<template>
  <i
    class="tm-visual-span"
    @mouseenter="$_toggleHover"
    @mouseleave="$_toggleHover"
  >
    <i class="tm-visual-material" :style="styleObj" />

    <i
      v-if="$props.isSceneEdit"
      class="tm-visual-sem-mark"
      :style="semMarkStyleObj"
    />

    <tm-visual-sprite
      :style="styleObj"
      :track="$props.track"
      :rectangle="$props.rectangle"
      :showDim="showDim"
      :isSelected="$props.isSelected"
      :isSceneEdit="$props.isSceneEdit"
    />

    <tm-visual-expired
      :style="styleObj"
      :track="$props.track"
      :isSceneEdit="$props.isSceneEdit"
      :rectangle="$props.rectangle"
      :isFirst="$props.isFirst"
      :isBanner="isLongest"
    />

    <tm-visual-status
      :style="styleObj"
      :rtpState="$props.track.rtpState"
      :isSceneEdit="$props.isSceneEdit"
      :isResizing="$props.track.isResizing"
      :rectangle="$props.rectangle"
      :isBanner="isLongest"
    />

    <tm-visual-badge
      v-if="$props.isFirst"
      :style="styleObj"
      :track="$props.track"
      :isSceneEdit="$props.isSceneEdit"
    />

    <tm-visual-text
      :style="styleObj"
      :track="$props.track"
      :rectangle="$props.rectangle"
      :isFirst="$props.isFirst"
      :isLast="$props.isLast"
      :videoTranscript="$props.videoTranscript"
      :isSelected="$props.isSelected"
      :isHovered="$props.isHovered"
    />

    <tm-visual-scenes
      :style="styleObj"
      :track="$props.track"
      :scenes="$props.scenes"
      :rectangle="$props.rectangle"
      :isSelected="$props.isSelected"
      :isHovered="$props.isHovered"
      v-if="showTimelineScenes"
    />

    <tm-visual-border
      :style="styleObj"
      :isFirst="$props.isFirst"
      :isLast="$props.isLast"
      :showBorder="$props.showBorder"
      :replaceStyle="isTargetForReplace"
      :rectangle="$props.rectangle"
    />

    <tm-visual-empty-scene
      :isRelevant="showEmptyScene"
      :rectangle="$props.rectangle"
    />
  </i>
</template>

<script>
import { mapState } from 'vuex';
import tmVisualSprite from './tmVisualSprite.vue';
import tmVisualBorder from './tmVisualBorder.vue';
import tmVisualBadge from './tmVisualBadge.vue';
import tmVisualText from './tmVisualText.vue';
import tmVisualExpired from './inlay/tmVisualExpired.vue';
import tmVisualStatus from './inlay/tmVisualStatus.vue';
import tmVisualEmptyScene from './inlay/tmVisualEmptyScene.vue';
import tmVisualScenes from './tmVisualScenes.vue';

export default {
  name: 'tm-visual-span',
  components: {
    tmVisualEmptyScene,
    tmVisualSprite,
    tmVisualExpired,
    tmVisualStatus,
    tmVisualBorder,
    tmVisualBadge,
    tmVisualText,
    tmVisualScenes,
  },

  props: {
    track: { type: Object, required: true },
    rectangle: { type: Object, required: true },
    videoTranscript: { type: Object, required: false, default: null },
    scenes: { type: Array, required: false, default: () => [] },
    isSelected: { type: Boolean, required: true },
    isFirst: { type: Boolean, required: true },
    isLast: { type: Boolean, required: true },
    showBorder: { type: Boolean, required: true },
    isHovered: { type: Boolean, required: true },
    isSceneEdit: { type: Boolean, required: true },
  },

  computed: {
    ...mapState('timemachine', {
      track2replace: (state) => state.dndEscort.track2replace,
      MODE_SCENE_EDIT: (state) => state.MODE.SCENE_EDIT,
      pxRowBlankTop: (state) => state.cssVariables.pxRowBlankTop,
      pxAssetHeight: (state) => state.cssVariables.pxAssetHeight,
      actingPipa: (state) => state.sceneEscort?.actingPipa,
      showTimelineScenes: (state) => state.USE.showTimelineScenes,
    }),

    styleObj() {
      // console.log('updated styleObj for x', this.rectangle.startTime);
      return {
        transform: `translate3d(${this.$props.rectangle.p1.x}px, ${
          this.$props.rectangle.p1.y + this.pxRowBlankTop
        }px, 0)`,
        width: `${this.$props.rectangle.width}px`,
        height: `${this.pxAssetHeight}px`,
      };
    },

    semMarkStyleObj() {
      // console.log('updated styleObj for x', this.rectangle.startTime);
      return {
        transform: `translate3d(${this.$props.rectangle.p1.x}px, ${
          this.$props.rectangle.p1.y + this.pxRowBlankTop
        }px, 0)`,
        width: `${this.$props.rectangle.width}px`,
      };
    },

    isLongest() {
      return this.$props.rectangle.isLongest;
    },

    isTargetForReplace() {
      return !this.MODE_SCENE_EDIT && this.track2replace === this.$props.track;
    },

    showDim() {
      return (
        !this.MODE_SCENE_EDIT &&
        (this.$props.isHovered || this.isTargetForReplace)
      );
    },

    showEmptyScene() {
      return this.isSceneEdit && this.isLongest && this.actingPipa.isEmpty();
    },
  },

  methods: {
    $_toggleHover(e) {
      this.$emit('hovered', e.type === 'mouseenter', this.$props.rectangle);
    },
  },
};
</script>

<style lang="scss">
.tm-visual > .tm-visual-span {
  .tm-visual-material {
    position: absolute;
    top: 0;
    background-color: rgba(0, 0, 0, 0.3);
  }

  .tm-visual-sem-mark {
    position: absolute;
    top: calc(-1 * var(--tm-pxSceneEditH));
    height: calc(1 * var(--tm-pxSceneEditH));
    background-color: var(--tm-semMarkColour);
    pointer-events: none;
  }
}
</style>
